<template>
    <div class="sswh_container">
        <!-- 栏目分类胶囊 -->
        <div class="sswh_tabs">
            <div
                class="sswh_tab"
                v-for="item in yjzsInfo"
                :key="item.typeId"
                :class="{ active: tabTypeId === item.typeId }"
                @click="changeType(item.typeId)">
                {{ item.typeName }}
            </div>
        </div>

        <div class="sswh_content">
            <!-- 宣传片 -->
            <div :class="tabTypeId == 1 ? 'sswh_panel' : 'sswh_panel_hide'">
                <div class="xcp_container reveal-init" v-reveal>
                    <div class="xcp_title_container">企业宣传片</div>
                    <div class="xcp_subTitle_container">
                        <div class="hr_line_left"></div>
                        <div class="xcp_center_container">源于自然 高于自然</div>
                        <div class="hr_line_right"></div>
                    </div>
                    <div class="xcp_video_container">
                        <div class="xcp_video_content">
                            <video-player class="video-player vjs-custom-skin"
                                ref="videoPlayer"
                                :playsinline="true"
                                poster
                                webkit-playsinline="true"
                                x-webkit-airplay="true"
                                :options="playerOptions">
                            </video-player>
                        </div>
                    </div>
                </div>
            </div>

            <!-- 员工风采 -->
            <div :class="tabTypeId == 2 ? 'sswh_panel' : 'sswh_panel_hide'">
                <div class="ygfc_caontainer reveal-init" v-reveal v-if="PlayerOptionsList.length > 0">
                    <div class="ygfc_video_container">
                        <div class="ygfc_item_container pc_video" v-for="item in PlayerOptionsList" :key="item.videoname">
                            <div class="ygfc_item_video__container">
                                <video-player class="video-player vjs-custom-skin"
                                    ref="videoPlayer"
                                    :playsinline="true"
                                    poster
                                    webkit-playsinline="true"
                                    x-webkit-airplay="true"
                                    :options="item">
                                </video-player>
                            </div>
                            <div class="ygfc_item_words__container" @click="priewVideo(item)">
                                <el-link type="primary" :underline="false">{{ item.videoname }}</el-link>
                            </div>
                        </div>
                        <div class="ygfc_item_container mb_video" v-for="item in MBPlayerOptionsList" :key="item.videoname">
                            <div class="ygfc_item_video__container">
                                <video-player class="video-player vjs-custom-skin"
                                    ref="videoPlayer"
                                    :playsinline="true"
                                    poster
                                    webkit-playsinline="true"
                                    x-webkit-airplay="true"
                                    :options="item">
                                </video-player>
                            </div>
                            <div class="ygfc_item_words__container">
                                <el-link type="primary" :underline="false">{{ item.videoname }}</el-link>
                            </div>
                        </div>
                    </div>
                    <div class="ygfc_page_container">
                        <el-pagination
                            layout="prev, pager, next"
                            @current-change="videoPageChanged"
                            :current-page="videoPageInfo.currentPage"
                            :total="videoPageInfo.totals"
                            :page-size="videoPageInfo.pageSize">
                        </el-pagination>
                    </div>
                </div>
                <div class="ygfc_caontainer reveal-init" v-reveal v-else>暂无数据</div>
            </div>

            <!-- 项目展示 -->
            <div :class="tabTypeId == 3 ? 'sswh_panel' : 'sswh_panel_hide'">
                <div class="ygfc_caontainer reveal-init" v-reveal v-if="PlayerOptionsList.length > 0">
                    <div class="ygfc_video_container">
                        <div class="ygfc_item_container pc_video" v-for="item in PlayerOptionsList" :key="item.videoname">
                            <div class="ygfc_item_video__container">
                                <video-player class="video-player vjs-custom-skin"
                                    ref="videoPlayer"
                                    :playsinline="true"
                                    poster
                                    webkit-playsinline="true"
                                    x-webkit-airplay="true"
                                    :options="item">
                                </video-player>
                            </div>
                            <div class="ygfc_item_words__container" @click="priewVideo(item)">
                                <el-link type="primary" :underline="false">{{ item.videoname }}</el-link>
                            </div>
                        </div>
                        <div class="ygfc_item_container mb_video" v-for="item in MBPlayerOptionsList" :key="item.videoname">
                            <div class="ygfc_item_video__container">
                                <video-player class="video-player vjs-custom-skin"
                                    ref="videoPlayer"
                                    :playsinline="true"
                                    poster
                                    webkit-playsinline="true"
                                    x-webkit-airplay="true"
                                    :options="item">
                                </video-player>
                            </div>
                            <div class="ygfc_item_words__container">
                                <el-link type="primary" :underline="false">{{ item.videoname }}</el-link>
                            </div>
                        </div>
                    </div>
                    <div class="ygfc_page_container">
                        <el-pagination
                            layout="prev, pager, next"
                            @current-change="videoPageChanged"
                            :current-page="videoPageInfo.currentPage"
                            :total="videoPageInfo.totals"
                            :page-size="videoPageInfo.pageSize">
                        </el-pagination>
                    </div>
                </div>
                <div class="ygfc_caontainer reveal-init" v-reveal v-else>暂无数据</div>
            </div>

            <!-- 推荐文章 -->
            <div :class="tabTypeId == 4 ? 'sswh_panel' : 'sswh_panel_hide'">
                <div class="sswh_list" v-if="tjwzInfo.length > 0">
                    <div
                        class="sswh_item reveal-init"
                        v-for="(item, idx) in tjwzInfo"
                        :key="item.articleid"
                        v-reveal="idx * 70">
                        <div class="sswh_item_thumb" @click="showArticleDeltail(item)">
                            <el-image :src="item.articlefaceimg" fit="cover">
                                <div slot="error" class="image-slot">
                                    <i class="el-icon-picture-outline" style="font-size: 40px;"></i>
                                </div>
                            </el-image>
                        </div>
                        <div class="sswh_item_body">
                            <div class="sswh_item_title" @click="showArticleDeltail(item)">{{ item.articletitle }}</div>
                            <div class="sswh_item_meta">
                                <span class="sswh_item_date">{{ item.articledate }}</span>
                                <el-button type="text" class="sswh_item_more" @click="showArticleDeltail(item)">查看详情 →</el-button>
                            </div>
                            <div class="sswh_item_excerpt" v-html="item.articletext"></div>
                        </div>
                    </div>
                    <div class="sswh_pager">
                        <el-pagination
                            layout="prev, pager, next"
                            @current-change="pageChanged"
                            :current-page="pageInfo.currentPage"
                            :total="pageInfo.totals"
                            :page-size="pageInfo.pageSize">
                        </el-pagination>
                    </div>
                </div>
                <div class="sswh_empty" v-else>暂无数据</div>
            </div>

            <!-- 企业宣传册 -->
            <div :class="tabTypeId == 5 ? 'sswh_panel' : 'sswh_panel_hide'">
                <iframe src="https://www.iznhc.com/index/ebook/book?ids=4052" width="100%" height="600px" border="0"></iframe>
            </div>
        </div>

        <!-- 视频预览 -->
        <el-dialog :visible.sync="videoDialogVisiable" class="videoDialog" width="700px" @close="dialogClose">
            <video-player class="video-player vjs-custom-skin"
                ref="videoPlayer"
                :playsinline="true"
                poster
                webkit-playsinline="true"
                x-webkit-airplay="true"
                :options="previewVieoOptions">
            </video-player>
        </el-dialog>
    </div>
</template>

<script>
export default {
  data () {
    return {
      previewVieo: '',
      previewVieoOptions: {
        playbackRates: [0.5, 1.0, 1.5, 2.0],
        autoplay: true,
        muted: false,
        loop: true,
        preload: 'auto',
        language: 'zh-CN',
        aspectRatio: '16:9',
        fluid: true,
        sources: [{ type: 'video/mp4', src: '' }],
        notSupportedMessage: '此视频暂无法播放，请稍后再试',
        controlBar: {
          timeDivider: false,
          durationDisplay: false,
          remainingTimeDisplay: false,
          fullscreenToggle: true
        }
      },
      videoDialogVisiable: false,
      playerOptions: {
        playbackRates: [0.5, 1.0, 1.5, 2.0],
        autoplay: true,
        muted: false,
        loop: true,
        preload: 'auto',
        language: 'zh-CN',
        aspectRatio: '16:9',
        fluid: true,
        sources: [{ type: 'video/mp4', src: '' }],
        notSupportedMessage: '此视频暂无法播放，请稍后再试',
        controlBar: {
          timeDivider: false,
          durationDisplay: false,
          remainingTimeDisplay: false,
          fullscreenToggle: true
        }
      },
      tabTypeId: 1,
      activeCzlcId: '',
      yjzsInfo: [
        { typeName: '宣传片', typeId: 1 },
        { typeName: '员工风采', typeId: 2 },
        { typeName: '项目展示', typeId: 3 },
        { typeName: '推荐文章', typeId: 4 },
        { typeName: '企业宣传册', typeId: 5 }
      ],
      videoPageInfo: {
        currentPage: 1,
        totals: 0,
        pageSize: 12
      },
      pageInfo: {
        currentPage: 1,
        totals: 0,
        pageSize: 3
      },
      videoList: [],
      MBPlayerOptionsList: [],
      PlayerOptionsList: [],
      tjwzInfo: [],
      videoType: 1
    }
  },
  methods: {
    dialogClose () {},
    priewVideo (url) {
      this.previewVieoOptions.sources[0].src = url.sources[0].src
      this.videoDialogVisiable = true
    },
    showArticleDeltail (data) {
      window.sessionStorage.setItem('articleDetail', JSON.stringify(data))
      window.sessionStorage.setItem('activeIndex', '/sswh')
      this.$router.push('articleDetail')
    },
    getTjwzByPage () {
      this.$http.post('/admin/getArticleByType/5', this.pageInfo).then(res => {
        this.tjwzInfo = res.data.articles
        this.pageInfo.totals = res.data.totals
      })
    },
    getXuanChuanPian () {
      this.$http.get('/admin/getVideoByType/3').then(res => {
        if (res.data.data.length > 0) {
          this.playerOptions.sources[0].src = res.data.data[0].videourl
        }
      })
    },
    getVideoByType (type) {
      this.$http.post('/admin/getVideoByTypeLimit/' + type, this.videoPageInfo).then(res => {
        const videoList = res.data.data
        this.videoPageInfo.totals = res.data.totals
        this.PlayerOptionsList = []
        this.MBPlayerOptionsList = []
        for (let index = 0; index < videoList.length; index++) {
          const options = {
            videoname: videoList[index].videoname,
            playbackRates: false,
            autoplay: false,
            muted: false,
            loop: true,
            preload: 'auto',
            language: 'zh-CN',
            aspectRatio: '16:9',
            fluid: true,
            sources: [{ type: 'video/mp4', src: videoList[index].videourl }],
            poster: '',
            notSupportedMessage: '此视频暂无法播放，请稍后再试',
            controlBar: false
          }
          const MBoptions = {
            videoname: videoList[index].videoname,
            playbackRates: false,
            autoplay: false,
            muted: false,
            loop: true,
            preload: 'auto',
            language: 'zh-CN',
            aspectRatio: '16:9',
            fluid: true,
            sources: [{ type: 'video/mp4', src: videoList[index].videourl }],
            poster: '',
            notSupportedMessage: '此视频暂无法播放，请稍后再试',
            controlBar: {
              timeDivider: false,
              durationDisplay: false,
              remainingTimeDisplay: false,
              fullscreenToggle: true
            }
          }
          this.MBPlayerOptionsList.push(MBoptions)
          this.PlayerOptionsList.push(options)
        }
      })
    },
    handleClick (tab, event) {
      console.log(tab, event)
    },
    changeType (typeId) {
      this.tabTypeId = typeId
      this.videoPageInfo = {
        currentPage: 1,
        totals: 0,
        pageSize: 12
      }
      if (typeId === 1) {
        this.getXuanChuanPian()
      } else if (typeId === 2) {
        this.videoType = 1
        this.getVideoByType(1)
      } else if (typeId === 3) {
        this.videoType = 2
        this.getVideoByType(2)
      } else if (typeId === 4) {
        this.getTjwzByPage()
      }
    },
    showDetails (data) {
      console.log(data)
    },
    pageChanged (currentPage) {
      this.pageInfo.currentPage = currentPage
      this.getTjwzByPage()
    },
    videoPageChanged (currentPage) {
      this.videoPageInfo.currentPage = currentPage
      this.getVideoByType(this.videoType)
    }
  },
  directives: {
    // 进场动画指令：内容默认可见，动画仅作「进场增强」。
    reveal: {
      inserted (el, binding) {
        const delay = binding.value || 0
        el.style.setProperty('--reveal-delay', delay + 'ms')
        const vh = window.innerHeight || document.documentElement.clientHeight
        const rect = el.getBoundingClientRect()
        if (rect.top < vh && rect.bottom > 0) {
          requestAnimationFrame(() => el.classList.add('reveal-in'))
        } else {
          const io = new IntersectionObserver((entries) => {
            entries.forEach((entry) => {
              if (entry.isIntersecting) {
                el.classList.add('reveal-in')
                io.unobserve(el)
              }
            })
          }, { threshold: 0.1, rootMargin: '0px 0px -8% 0px' })
          io.observe(el)
        }
      }
    }
  },
  created () {
    this.changeType(1)
  }
}
</script>

<style lang="less" scoped>
.sswh_container {
    --ss-green-800: #163a2b;
    --ss-green: #2e6b4f;
    --ss-green-200: #e3ece5;
    --ss-sand: #f7f5f0;
    --ss-gold: #c9a86a;

    width: 100%;
    background: #fff;
    border-radius: 8px;
    padding: 0 0 16px;
    overflow: hidden;
}

/* 栏目分类胶囊 */
.sswh_tabs {
    display: flex;
    flex-wrap: wrap;
    gap: 10px;
    padding: 18px 24px;
    border-bottom: 1px solid #ece8df;
}
.sswh_tab {
    padding: 8px 22px;
    border-radius: 999px;
    font-size: 15px;
    color: #5b6b62;
    cursor: pointer;
    border: 1px solid transparent;
    transition: background .3s ease, color .3s ease, box-shadow .3s ease;
}
.sswh_tab:hover {
    color: var(--ss-green);
    background: #eef3f0;
}
.sswh_tab.active {
    background: var(--ss-green);
    color: #fff;
    box-shadow: 0 4px 12px rgba(22, 58, 43, .18);
}

.sswh_content {
    padding: 24px;
}

/* 进场动画（默认可见 + 渐显，防呆不隐藏） */
.reveal-init { }
.reveal-init.reveal-in {
    animation: sswhReveal .7s cubic-bezier(.22, .61, .36, 1) both;
    animation-delay: var(--reveal-delay, 0ms);
}
@keyframes sswhReveal {
    from { opacity: 0; transform: translateY(26px); }
    to   { opacity: 1; transform: none; }
}

/* 面板显隐（保留常驻挂载，避免视频/iframe 重载） */
.sswh_panel {
    width: 100%;
    min-height: 200px;
    overflow: hidden;
}
.sswh_panel_hide {
    width: 100%;
    height: 0;
    overflow: hidden;
}

/* 宣传片 */
.xcp_container {
    width: 100%;
    min-height: 450px;
}
.xcp_title_container {
    width: 100%;
    padding: 10px 0;
    font-size: 200%;
    font-weight: 200;
    text-align: center;
    letter-spacing: .1rem;
    color: var(--ss-green-800);
}
.xcp_subTitle_container {
    width: 100%;
    height: 100px;
    position: relative;
    display: flex;
    align-items: center;
    justify-content: center;
}
.hr_line_left {
    width: 300px;
    height: 1px;
    background-color: var(--ss-green);
    position: absolute;
    left: 150px;
}
.hr_line_right {
    width: 300px;
    height: 1px;
    background-color: var(--ss-green);
    position: absolute;
    right: 150px;
}
.xcp_center_container {
    width: 300px;
    height: 80px;
    border: 1px solid var(--ss-green);
    display: flex;
    justify-content: center;
    align-items: center;
    font-size: 150%;
    font-weight: 200;
    color: var(--ss-green-800);
}
.xcp_video_container {
    width: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    position: relative;
}
.xcp_video_content {
    width: 80%;
    height: 100%;
}
@media screen and (min-width: 768px) and (max-width: 1200px) {
    .xcp_video_content { width: 800px; }
    .hr_line_left { left: 80px; }
    .hr_line_right { right: 80px; }
}
@media screen and (min-width: 500px) and (max-width: 768px) {
    .hr_line_left { width: 250px; left: 10px; }
    .hr_line_right { width: 250px; right: 10px; }
}
@media screen and (max-width: 500px) {
    .xcp_title_container { font-size: 150%; }
    .xcp_center_container { width: 180px; height: 50px; font-size: 120%; }
    .xcp_subTitle_container { height: 70px; }
    .hr_line_left { width: 100px; left: 5px; }
    .hr_line_right { width: 100px; right: 5px; }
}

/* 员工风采 / 项目展示 */
.ygfc_caontainer {
    width: 100%;
}
.ygfc_video_container {
    width: 100%;
    display: flex;
    align-items: flex-end;
    flex-wrap: wrap;
    justify-content: center;
}
.ygfc_page_container {
    width: 100%;
    height: 50px;
    display: flex;
    align-items: center;
    justify-content: center;
}
.ygfc_item_container {
    width: 30%;
    cursor: pointer;
    float: left;
    padding: 10px;
    transition: transform .3s ease;
}
.ygfc_item_container:hover {
    transform: translateY(-4px);
}
@media screen and (min-width: 768px) and (max-width: 1200px) {
    .ygfc_item_container { width: 33%; }
}
@media screen and (min-width: 500px) and (max-width: 768px) {
    .ygfc_item_container { width: 50%; }
}
@media screen and (max-width: 500px) {
    .ygfc_item_container { width: 100%; padding: 5px; }
}
.ygfc_item_words__container {
    width: 100%;
    height: 24px;
    line-height: 20px;
    padding: 5px;
    font-size: 15px;
    display: -webkit-box;
    text-overflow: ellipsis;
    -webkit-line-clamp: 1;
    -webkit-box-orient: vertical;
    background-color: #fff;
    overflow: hidden;
}

/* 推荐文章（报刊细线紧凑列表，与 xwzx 一致） */
.sswh_list {
    width: 100%;
}
.sswh_item {
    display: flex;
    gap: 20px;
    align-items: flex-start;
    padding: 22px 8px;
    border-bottom: 1px solid #ece8df;
    transition: background .3s ease;
}
.sswh_item:hover {
    background: linear-gradient(90deg, rgba(46, 107, 79, .05), rgba(46, 107, 79, 0));
}
.sswh_item_thumb {
    flex: 0 0 200px;
    width: 200px;
    height: 132px;
    border-radius: 10px;
    overflow: hidden;
    cursor: pointer;
}
.sswh_item_thumb ::v-deep .el-image {
    width: 100%;
    height: 100%;
}
.sswh_item_thumb ::v-deep .el-image__inner {
    transition: transform .6s cubic-bezier(.22, .61, .36, 1);
}
.sswh_item:hover .sswh_item_thumb ::v-deep .el-image__inner {
    transform: scale(1.06);
}
.sswh_item_body {
    flex: 1;
    min-width: 0;
}
.sswh_item_title {
    font-size: 20px;
    font-weight: 600;
    color: var(--ss-green-800);
    line-height: 1.45;
    position: relative;
    display: inline-block;
    cursor: pointer;
    transition: color .3s ease;
}
.sswh_item_title::after {
    content: '';
    position: absolute;
    left: 0;
    bottom: -4px;
    width: 100%;
    height: 2px;
    background: var(--ss-gold);
    transform: scaleX(0);
    transform-origin: left;
    transition: transform .4s ease;
}
.sswh_item:hover .sswh_item_title {
    color: var(--ss-gold);
}
.sswh_item:hover .sswh_item_title::after {
    transform: scaleX(1);
}
.sswh_item_meta {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin: 10px 0;
}
.sswh_item_date {
    color: var(--ss-gold);
    font-size: 14px;
}
.sswh_item_more {
    color: var(--ss-green) !important;
    font-size: 14px;
    padding: 0 !important;
}
.sswh_item_excerpt {
    color: #56635b;
    font-size: 15px;
    line-height: 1.7;
    display: -webkit-box;
    overflow: hidden;
    text-overflow: ellipsis;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
}
.sswh_pager {
    display: flex;
    justify-content: center;
    padding: 30px 0 6px;
}
.sswh_empty {
    padding: 70px 0;
    text-align: center;
    color: #9aa39c;
    font-size: 15px;
}
@media screen and (max-width: 768px) {
    .sswh_content { padding: 16px; }
    .sswh_item { flex-direction: column; gap: 12px; padding: 18px 4px; }
    .sswh_item_thumb { width: 100%; flex: none; height: 180px; }
}

/* 企业宣传册 iframe */
.sswh_panel iframe {
    border: 0;
    display: block;
}

.videoDialog {
    display: block;
}
.mb_video {
    display: none;
}
@media screen and (max-width: 500px) {
    .videoDialog { display: none; }
    .pc_video { display: none; }
    .mb_video { display: block; }
}
</style>
